import React from 'react';
import { Card, Nav } from 'react-bootstrap';

export interface NavTabType {
    label: string | JSX.Element;
    val: string;
}
interface NavTabsProps {
    tabs: NavTabType[];
    page: string;
    setPage: (x: string) => void;
}
export function NavTabs({ tabs, page, setPage }: NavTabsProps) {
    return (
        <Card.Header className="patient-details_nav">
            <Nav variant="tabs" className="card-header-tabs">
                {tabs.map((x) => (
                    <Nav.Item key={x.val}>
                        <Nav.Link
                            className={x.val === page ? 'active' : ''}
                            onClick={() => setPage(x.val)}
                        >
                            {x.label}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
        </Card.Header>
    );
}
